import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useHub } from "../../context/HubContext";
import { Bell, ChevronDown, Building2 } from "lucide-react";

const pageTitles = {
  "/overview": "Overview",
  "/events": "Events",
  "/attendees": "Attendees",
  "/hub-partners": "Hub Partners",
  "/reports": "Reports",
  "/wallet": "Wallet",
};

const getInitials = (user) =>
  `${user?.name?.[0] ?? ""}${user?.surname?.[0] ?? ""}`.toUpperCase();

const Topbar = () => {
  const { user } = useAuth();
  const { hub, hubs, setHub } = useHub();
  const location = useLocation();
  const title = pageTitles[location.pathname] ?? "Ingroove";

  return (
    <div className="h-14 bg-bg-topbar border-b border-border flex items-center justify-between px-6 flex-shrink-0">
      {/* Left — page title */}
      <div>
        <h1 className="text-sm font-semibold text-text-primary">{title}</h1>
        <p className="text-xs text-text-muted">
          {new Date().toLocaleDateString("en-ZA", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>
      </div>

      {/* Right */}
      <div className="flex items-center gap-3">
        {/* Hub switcher — only if user has multiple hubs */}
        {hubs.length > 1 && (
          <div className="relative group">
            <button className="flex items-center gap-2 px-3 py-1.5 bg-bg-elevated border border-border rounded-xl text-xs text-text-secondary hover:border-primary transition">
              <Building2 size={13} className="text-primary" />
              <span className="max-w-[120px] truncate">{hub?.name}</span>
              <ChevronDown size={12} />
            </button>
            <div className="absolute right-0 top-full mt-2 w-48 bg-bg-elevated border border-border rounded-xl shadow-card overflow-hidden opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition z-50">
              {hubs.map((h) => (
                <button
                  key={h.id}
                  onClick={() => setHub(h)}
                  className={`w-full text-left px-4 py-2.5 text-xs transition ${
                    hub?.id === h.id
                      ? "text-primary bg-primary/10"
                      : "text-text-secondary hover:bg-bg-overlay"
                  }`}
                >
                  {h.name}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Single hub name badge */}
        {hubs.length === 1 && hub && (
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-bg-elevated border border-border rounded-xl text-xs text-text-secondary">
            <Building2 size={13} className="text-primary" />
            <span className="max-w-[120px] truncate">{hub.name}</span>
          </div>
        )}

        {/* Notifications */}
        {/* <button className="relative w-8 h-8 rounded-xl bg-bg-elevated border border-border flex items-center justify-center text-text-muted hover:text-primary hover:border-primary transition">
          <Bell size={15} />
        </button> */}

        {/* Avatar */}
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-xl ingroove-gradient-bg flex items-center justify-center text-white text-xs font-bold shadow-glow">
            {getInitials(user)}
          </div>
          <div className="hidden sm:block">
            <p className="text-xs font-medium text-text-secondary">
              {user?.name} {user?.surname}
            </p>
            <p className="text-xs text-text-hint">{user?.email}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
